import { state } from '@/core/store/general/state';
import { getters } from '@/core/store/general/getters';
import { mutations } from '@/core/store/general/mutations';
import { actions } from '@/core/store/general/action';

export const general = {
    state,
    getters,
    actions,
    mutations,
};
